import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
let mix = (superclass) => new MixinBuilder(superclass);

import B_Define from '../../util/B_Define';
import B_Real from '../base/B_Real';
import B_ChildTool from '../base/B_ChildTool';
import B_Shape from '../shape/B_Shape';
import B_ShapeHeader from '../shape/B_ShapeHeader';

class B_HeaderScore extends mix(B_Real).with(B_ChildTool, B_Shape, B_ShapeHeader) {
	constructor(inputJson) {
		super(inputJson);

		this._WIDTH = this.CODMOS.CANVAS.width / 2 * 0.8;
		this._container.x = this.CODMOS.CANVAS.width / 2;
		this._HEIGHT = this._WIDTH / 4;

		// [S] shape & icon & text 생성
		this._bg = new createjs.Shape();
		this._bg.graphics
			.beginFill('#aeadad')
			.drawRoundRectComplex(0, 0, this._WIDTH, this._HEIGHT, 0, 10, 10, 0);
		this._boxShadow = new createjs.Shape();
		this._boxShadow.graphics
			.beginFill('#9c9b9b')
			.drawRoundRectComplex(0, -2, this._WIDTH, this._HEIGHT, 0, 10, 10, 0);
		this._container.addChild(this._boxShadow);
		this._container.addChild(this._bg);

		this[B_Define.SCORE_ICON_ID] = new createjs.Text('SCORE', '18px GothamBlack', '#fff');
		const { width: iconW, height: iconH } = this[B_Define.SCORE_ICON_ID].getBounds();
		const margin = 15;
		this[B_Define.SCORE_ICON_ID].y = this._HEIGHT / 2 - iconH / 2;
		this[B_Define.SCORE_ICON_ID].x = margin;
		this._container.addChild(this[B_Define.SCORE_ICON_ID]);
		this[B_Define.SCORE_TEXT_ID] = new createjs.Text(B_Define.SCORE_INIT_VALUE, '25px GothamBlack', '#fff');
		this[B_Define.SCORE_TEXT_ID].y = this._HEIGHT / 2 - this[B_Define.SCORE_TEXT_ID].getBounds().height / 2;
		this[B_Define.SCORE_TEXT_ID].x = margin * 2 + iconW;
		this._container.addChild(this[B_Define.SCORE_TEXT_ID]);
	}

	// [F] public

	/**
	 * [Function :: getScore]
	 *
	 * @DES :: 스코어 얻기
	 * @IP1 ::
	 * @O.P ::
	 * @S.E ::
	 */
	getScore () {
		return this._numScore;
	}

	/**
	 * [Function :: setScore]
	 *
	 * @DES :: 스코어 수정하기
	 * @IP1 :: numScore {num}
	 * @O.P ::
	 * @S.E ::
	 */
	setScore (numScore) {
		numScore = parseInt(numScore);
		this._numScore = numScore;
		this[B_Define.SCORE_TEXT_ID].text = numScore; // [*] 텍스트 설정후
		// this[B_Define.SCORE_TEXT_ID]._setPoint(50,50); // [*] 중심 재설정
		// this._fitShape(this._WIDTH, this._HEIGHT, B_Define.SHAPE_BG); // [*]
	}
}

export default B_HeaderScore;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_HeaderScore.js